import React, { useEffect, useRef, useState } from 'react'
import Title from '../components/common/Title'
import { Topbar } from '../components/include/Topbar'
import { useParams } from 'react-router-dom';
import ApprovalModal from '../components/ApprovalModal';
import { Postdata } from '../helpers/api.service';
import HttpService from '../helpers/httpServices';
import { message } from '../redux/actions/toastActions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../components/common/Loader';
import camera from "../assets/camera.svg"
import pin from "../assets/pin.svg"
import trash from "../assets/trash.png"
import phoneIcon from "../assets/Icons/world.svg"
import { toast } from 'sonner';

const School_profile = () => {
  const [aboutImage, setAboutImage] = useState(null);
  const aboutFileInputRef = useRef(null);
  const { id } = useParams();
  const [previewURL, setPreviewURL] = useState(null);
  const fileInputRef = useRef();
  const [pictures, setPictures] = useState([]);
  const [errors, setErrors] = useState({});
  const [deletedFiles, setDeletedFiles] = useState([])
  const historyFileInputRef = useRef(null);
  const [historyImage, setHistoryImage] = useState(null);
  const [valueImage, setValueImage] = useState(null);
  const [loader, setLoader] = useState(false);

  const whyUsFileInputRef = useRef(null);
  const valueFileInputRef = useRef(null);
  const [whyUsImage, setWhyUsImage] = useState(null);
  const dispatch = useDispatch()
  const schoolName = useSelector(state => state.auth.data.user.school_id?.name) || "";
  const [refresh, setRefresh] = useState(false);

  const [logoPreview, setLogoPreview] = useState(null);
  const [formData, setFormData] = useState({
    banner_image: "",
    logo: "",
    name: schoolName ?? "",
    tagline: "",
    email: "",
    mobile_number: "",
    addressline: "",
    landmark: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    about: "",
    history: "",
    value: "",
    why_us: "",
    school_email: "",
    school_mobile_number: "",
  });
  const [profileCompleted, setProfileCompleted] = useState(false)
  const [verified, setVerified] = useState(false)
  const handleHistoryFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { // 10MB
      toast.warning('Image size must be less than 5MB')
      e.target.value = "";
      return;
    }
    if (file) {
      setFormData((prev) => ({ ...prev, history_image: file }));
      setHistoryImage(URL.createObjectURL(file));
    }
  };

  const handleValueFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { // 10MB
      toast.warning('Image size must be less than 5MB')
      e.target.value = "";
      return;
    }
    if (file) {
      setFormData((prev) => ({ ...prev, value_image: file }));
      setValueImage(URL.createObjectURL(file));
    }
  };

  const removeHistoryImage = () => {
    setHistoryImage(null);
    historyFileInputRef.current.value = null;
  };
  const removeValueImage = () => {
    setValueImage(null);
    valueFileInputRef.current.value = null;
  };

  const handleWhyUsFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { // 10MB
      toast.warning('Image size must be less than 5MB')
      e.target.value = "";
      return;
    }
    if (file) {
      setFormData((prev) => ({ ...prev, why_us_image: file }));
      setWhyUsImage(URL.createObjectURL(file));
    }
  };

  const removeWhyUsImage = () => {
    setWhyUsImage(null);
    whyUsFileInputRef.current.value = null;
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    console.log("::::::::::::::::::::::::::::::::::::::::");
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { // 10MB
      toast.warning('Image size must be less than 5MB')
       e.target.value = "";
      return;
    }
    setFormData((prev) => ({ ...prev, banner_image: file }));
    setPreviewURL(URL.createObjectURL(file)); // For round preview
  };
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { // 10MB
      toast.warning('Image size must be less than 5MB')
      e.target.value = "";
      return;
    }
    setFormData((prev) => ({ ...prev, logo: file }));
    setLogoPreview(URL.createObjectURL(file)); // For round preview
  };

  const handleAboutFileChange = (e) => {
    const file = e.target.files[0];
    if (file.size > 5 * 1024 * 1024) { // 10MB
     toast.warning('Image size must be less than 5MB')
     e.target.value = "";
      return;
    }
    if (file) {
      setFormData((prev) => ({ ...prev, about_image: file }));
      setAboutImage(URL.createObjectURL(file));
    }
  };

  const removeAboutImage = () => {
    setAboutImage(null);
    aboutFileInputRef.current.value = null;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name?.trim()) newErrors.name = "School Name is required";
    if (!formData.tagline?.trim()) newErrors.tagline = "Tagline is required";
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.school_email?.trim()) {
      newErrors.school_email = "School Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.school_email)) {
      newErrors.school_email = "Invalid School Email format";
    }


    if (!formData.mobile_number?.trim()) {
      newErrors.mobile_number = "Contact number is required";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Contact number must be 10 digits";
    }
    if (!formData.school_mobile_number?.trim()) {
      newErrors.school_mobile_number = "School Contact number is required";
    } else if (!/^\d{10}$/.test(formData.school_mobile_number)) {
      newErrors.school_mobile_number = "School Contact number must be 10 digits";
    }

    if (!formData.addressline?.trim()) newErrors.addressline = "Address is required";
    if (!formData.landmark?.trim()) newErrors.landmark = "Landmark is required";
    if (!formData.country?.trim()) newErrors.country = "County is required";
    if (!formData.state?.trim()) newErrors.state = "Constituency is required";
    if (!formData.city?.trim()) newErrors.city = "Location is required";

    if (!formData.pincode?.trim()) {
      newErrors.pincode = "Postal Code is required";
       } else if (!/^\d{5}$/.test(formData.pincode)) {
           newErrors.pincode = "Postal Code must be exactly 5 digits";
      }

    if (!formData.about?.trim()) newErrors.about = "About is required";
    if (!formData.history?.trim()) newErrors.history = "Mission is required";
    if (!formData.why_us?.trim()) newErrors.why_us = "Vision is required";
    if (!formData.value?.trim()) newErrors.value = "Value is required";

    if (!previewURL) newErrors.banner_image = "Banner image is required";
    if (!logoPreview) newErrors.logo = "Logo is required";
    if (!aboutImage) newErrors.about_image = "image is required";
    if (!historyImage) newErrors.history_image = "image is required";
    if (!whyUsImage) newErrors.why_us_image = "image is required";
    if (!valueImage) newErrors.value_image = "image is required";
    // if (pictures.length === 0) newErrors.pictures = "At least one picture is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    // Replace with actual API call
    if (!validateForm()) {
      return;
    }

    console.log("formData", formData);
    let form = new FormData()
    form.append("banner_image", formData.banner_image)
    form.append("logo", formData.logo)
    form.append("name", formData.name)
    form.append("tagline", formData.tagline)
    form.append("email", formData.email)
    form.append("school_email", formData.school_email)
    form.append("school_mobile_number", formData.school_mobile_number)
    form.append("mobile_number", formData.mobile_number)
    form.append("addressline", formData.addressline)
    form.append("landmark", formData.landmark)
    form.append("country", formData.country)
    form.append("state", formData.state)
    form.append("city", formData.city)
    form.append("pincode", formData.pincode)
    form.append("about", formData.about)
    form.append("history", formData.history)
    form.append("why_us", formData.why_us)
    form.append("about_image", formData.about_image)
    form.append("history_image", formData.history_image)
    form.append("why_us_image", formData.why_us_image)
    form.append("value", formData.value)
    form.append("value_image", formData.value_image)
    // if (pictures.length > 0) {
    //   pictures.forEach((picture, i) => {
    //     form.append(`pictures`, picture);
    //   });
    // }
    setLoader(true)
    Postdata(HttpService.school_profile_update, form).then((res) => {
      if (res.status === 200) {
        setRefresh(!refresh);
      }
      setLoader(false)

      // dispatch(message(res.message));
    })
  };
  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.school_profile_show).then((res) => {
      if (res.status === 200) {
        let data = res.data
        setFormData({
          banner_image: data.banner_image,
          logo: data.logo,
          name: data.name,
          tagline: data.tagline,
          email: data.email,
          mobile_number: data.mobile_number,
          addressline: data.addressline,
          landmark: data.landmark,
          country: data.country,
          state: data.state,
          city: data.city,
          pincode: data.pincode,
          about: data.about,
          history: data.history,
          why_us: data.why_us,
          about_image: data.about_image,
          history_image: data.history_image,
          why_us_image: data.why_us_image,
          school_email: data.school_email,
          school_mobile_number: data.school_mobile_number,
          value: data.value,
          value_image: data.value_image,
        });
        setLogoPreview(data.logo);
        setPreviewURL(data.banner_image);
        setAboutImage(data.about_image);
        setHistoryImage(data.history_image);
        setWhyUsImage(data.why_us_image);
        setValueImage(data.value_image);
        setPictures(data.pictures);
        setProfileCompleted(data.is_profile_completed);
        setVerified(data.is_school_verified);
      } 
      setLoader(false)
    })
  }



  useEffect(() => {
    // Set school name in data state after schoolName is available
    console.log("schoolName>1", schoolName)
    if (schoolName) {
      setFormData(prev => ({ ...prev, name: schoolName }));
    }
    fetchData()
  }, [schoolName, refresh]);



  // if (loader || !schoolName) {
  //   return <Loader isClass="loader_fullscreen" />
  // }
  console.log("profileCompleted", profileCompleted)
  if (profileCompleted && !verified) {
    return <ApprovalModal isVisible={true} data={formData} />
  }
  return (
    <>
      <Title name="Profile" />
      <Topbar title="Complete Your Profile" />

      <div className=" mx-auto p-4">
        <form onSubmit={handleSubmit}>


          {/* Upload Banner */}
          <div className="relative mb-16">
            {/* Updated Banner Uploader */}
            <div className="border-gray-300 bg-white relative rounded-lg text-center text-gray-500 hover:border-gray-400 transition duration-300 ease-in-out">
              <label className="flex flex-col items-center justify-center cursor-pointer overflow-hidden">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="hidden"
                />

                {previewURL ? (
                  <div className="relative h-[300px] w-full">
                    <img
                      src={previewURL || formData?.banner_image}
                      alt="Preview"
                      className="w-full h-full object-cover rounded-xl"
                    />
                    {/* <span className="text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 font-medium">
                      + Upload Front Home Banner Image
                    </span> */}
                  </div>
                ) : (
                  <span className="text-primary_main py-[130px] rounded-xl font-medium">
                    + Upload Front Home Banner Image
                  </span>
                )}
                {errors.banner_image && (
                  <span className="text-red-500">{errors.banner_image}</span>
                )}
              </label>
            </div>

            {/* Profile Image Overlapping */}
            <div className="absolute left-20 -bottom-20">
              <label className="flex flex-col items-center justify-center w-24 h-24 rounded-full border-2 border-purple-500 cursor-pointer overflow-hidden">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleLogoUpload}
                  className="hidden"
                />
                {logoPreview ? (
                  <img
                    src={logoPreview}
                    alt="Preview"
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  // <span className="text-purple-500 text-3xl">📷</span>
                  <img src={camera} alt="Camera Icon" className=" " />
                )}
              </label>
              <label className="text-sm text-gray-600 text-center mt-1 ">
                School Logo<span className="text-red-500  ">*</span>
              </label>
            </div>
          </div>
          <br />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2 mb-4">
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">School Name<span className="text-red-500">*</span></label>
              <input
                  type="text"
                  placeholder="Enter School Name"
                  className="input-field"
                  value={formData.name}
                  onChange={(e) => {
                    // Allow only letters (a-zA-Z)
                    const value = e.target.value.replace(/[^a-zA-Z]/g, '');
                    setFormData({ ...formData, name: value });
                  }}
                />
              {errors.name && <span className="text-red-500 text-sm">{errors.name}</span>}
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Tagline<span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Enter Tagline"
                className="input-field"
                value={formData.tagline}
                onChange={(e) => setFormData({ ...formData, tagline: e.target.value })}
              />
              {errors.tagline && <span className="text-red-500 text-sm">{errors.tagline}</span>}
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Email ID<span className="text-red-500">*</span></label>
              <input
                type="email"
                placeholder="Enter School Email ID"
                className="input-field"
                value={formData.school_email}
                onChange={(e) => setFormData({ ...formData, school_email: e.target.value })}
              />
              {errors.school_email && <span className="text-red-500 text-sm">{errors.school_email}</span>}
            </div>
          </div>

          {/* Upload Pictures */}
          {/* <div className="mb-4">
            <label className="text-sm text-gray-600 mb-2 block">Upload Pictures</label>

            <div className="flex flex-col md:flex-row gap-6 items-start">
              
              <div className="w-fit md:w-1/3">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Select Image"
                    className="input-field"
                    readOnly
                  />
                  <button
                    type="button"
                    onClick={() => fileInputRef.current.click()}
                    className="absolute top-1/2 right-3 -translate-y-1/2 text-orange-600 font-semibold"
                  >
                    Upload
                  </button>
                </div>
                <input
                  type="file"
                  ref={fileInputRef}
                  name="file"
                  accept=".jpg,.jpeg,.png"
                  onChange={(e) => {
                    const files = Array.from(e.target.files);
                    const validFiles = [];
                    const maxSize = 10 * 1024 * 1024; // 10MB
                    const maxPictures = 10;

                    files.forEach((file) => {
                      if (file.size > maxSize) {
                        dispatch(message(`Image must be less than 10MB.`));
                      } else {
                        validFiles.push(file);
                      }
                    });

                    if ((pictures.length + validFiles.length) > maxPictures) {
                      dispatch(message(`You can upload a maximum of ${maxPictures} pictures.`));
                    } else {
                      if (validFiles.length > 0) {
                        setPictures((prev) => [...(prev || []), ...validFiles]);
                      }
                    }

                    e.target.value = '';
                  }}
                  className="hidden"
                />
                {errors.pictures && (
                  <span className="text-red-500 text-sm">Required</span>
                )}
              </div>

              
              <div className="flex flex-wrap gap-[14px] w-full md:w-1/2">
                {pictures.map((file, index) => (
                  <div
                    key={index}
                    className="relative rounded-md flex items-center justify-center"
                  >
                    <img
                      src={
                        typeof file === "string"
                          ? file
                          : URL.createObjectURL(file)
                      }
                      alt="img"
                      className="w-20 h-20 object-cover rounded-md"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setPictures((prev) => prev.filter((item, i) => i !== index));

                        if (typeof file === "string") {
                          setDeletedFiles((prev) => [...prev, file.split("/").pop()]);
                        }
                      }}
                      className="absolute -top-2 -right-2 bg-black text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-800"
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div> */}
          {/* Email & Contact */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
           
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Contact Number<span className="text-red-500">*</span></label>
              {/* <input
                type="tel"
                placeholder="Enter School Contact Number"
                className="input-field"
                value={formData.mobile_number}
                onChange={(e) => setFormData({ ...formData, mobile_number: e.target.value })}

              /> */}
              {/* <div className=' '>

              <span className="icon">
                <img src={phoneIcon} alt="phone icon" />
              </span>
              <input
                type="tel"
                placeholder="Enter School Contact Number"
                className="input-field"
                value={formData.mobile_number}
                onChange={(e) => setFormData({ ...formData, mobile_number: e.target.value })}
                
                />
                </div> */}
              <div className="flex items-center bg-white  border-gray-300 rounded-lg px-2  w-full">
                {/* Flag Icon */}
                <img
                  src="https://flagcdn.com/w20/ke.png" // Example Kenya flag
                  alt="flag"
                  className="w-6 h-6  rounded-full object-cover"
                />

                {/* Input */}
                <input
                  type="tel"
                  placeholder="Enter School Contact Number"
                  className="flex-1 input-field"
                  value={formData.school_mobile_number}
                  maxLength={12}
                  onChange={(e) => {
                    // Allow only numbers (0-9)
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setFormData({ ...formData, school_mobile_number: value });
                  }}
                />
              </div>


              {errors.school_mobile_number && <span className="text-red-500 text-sm">{errors.school_mobile_number}</span>}
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Admin Email ID<span className="text-red-500">*</span></label>
              <input
                type="email"
                placeholder="Enter Admin Email ID"
                className="input-field"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
              {errors.email && <span className="text-red-500 text-sm">{errors.email}</span>}
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Admin Contact Number<span className="text-red-500">*</span></label>
              
              <div className="flex items-center bg-white  border-gray-300 rounded-lg px-2  w-full">
                {/* Flag Icon */}
                <img
                  src="https://flagcdn.com/w20/ke.png" // Example Kenya flag
                  alt="flag"
                  className="w-6 h-6  rounded-full object-cover"
                />

                {/* Input */}
                <input
                  type="tel"
                  placeholder="Enter Admin Contact Number"
                  className="flex-1 input-field"
                  maxLength={12}
                  value={formData.mobile_number}
                   onChange={(e) => {
                    // Allow only numbers (0-9)
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setFormData({ ...formData, mobile_number: value });
                  }}
                />
              </div>


              {errors.mobile_number && <span className="text-red-500 text-sm">{errors.mobile_number}</span>}
            </div>
          </div>

          {/* Email & Contact */}
          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            
             <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Enter Sub Domain<span className="text-red-500">*</span></label>
              <div className='flex  '>

              <input
                type="text"
                placeholder="Enter Sub Domain"
                className="input-field max-w-[200px]"
                value={formData.subdomain}
                disabled={subdomain ? true : false}
                onChange={(e) => setFormData({ ...formData, subdomain: e.target.value })}
                />
                 <input
                type="text"
                // placeholder="Enter Sub Domain"
                className="input-field text-sm"
                value=".pstsquare.in"
                disabled={true}
                />
                </div>
              {errors.subdomain && <span className="text-red-500 text-sm">{errors.subdomain}</span>}
            </div>

          </div> */}
          <label className="text-sm text-gray-600 mb-1">Address</label>
          {/* Address */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Full Address <span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Enter school's Full Address"
                className="input-field"
                value={formData.addressline}
                onChange={(e) => setFormData({ ...formData, addressline: e.target.value })}
              />
              {errors.addressline && <span className="text-red-500 text-sm">{errors.addressline}</span>}
            </div>
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Landmark<span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Enter Nearest Landmark"
                className="input-field"
                value={formData.landmark}
                onChange={(e) => setFormData({ ...formData, landmark: e.target.value })}
              />
              {errors.landmark && <span className="text-red-500 text-sm">{errors.landmark}</span>}
            </div>

            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">County<span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Select County"
                className="input-field"
                value={formData.country}
                 onChange={(e) => {
                    // Allow only letters (a-zA-Z)
                    const value = e.target.value.replace(/[^a-zA-Z]/g, '');
                    setFormData({ ...formData, country: value });
                  }}
              />
              {errors.country && <span className="text-red-500 text-sm">{errors.country}</span>}
            </div>

          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">

            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Constituency<span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Select Constituency"
                className="input-field"
                value={formData.state}
                onChange={(e) => setFormData({ ...formData, state: e.target.value })}
              />
              {errors.state && <span className="text-red-500 text-sm">{errors.state}</span>}
            </div>

            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Location<span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Select Location"
                className="input-field"
                value={formData.city}
                onChange={(e) => setFormData({ ...formData, city: e.target.value })}
              />
              {errors.city && <span className="text-red-500 text-sm">{errors.city}</span>}
            </div>

            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-1">Postal Code<span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Enter Postal Code"
                className="input-field"
                value={formData.pincode}
                maxLength={5}
                 onChange={(e) => {
                    // Allow only letters (a-zA-Z)
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setFormData({ ...formData, pincode: value });
                  }}
              />
              {errors.pincode && <span className="text-red-500 text-sm">{errors.pincode}</span>}
            </div>

          </div>
          <label className="text-sm text-gray-600 mb-1">About</label>

          {/* About Sections */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            {/* About The School */}
          

            <div className="flex flex-col relative">
              <label className="text-sm text-gray-600 mb-1">About The School<span className="text-red-500">*</span></label>
              
              <div className="relative">
                <textarea
                  placeholder="Write Here..."
                  rows="4"
                  className="input-field  p-3 border rounded-md focus:ring-2 focus:ring-primary_main"
                  value={formData.about}
                  onChange={(e) => setFormData({ ...formData, about: e.target.value })}
                ></textarea>
                {errors.about && <span className="text-red-500 text-sm">{errors.about}</span>}
              </div>
             
              <div className="flex items-center justify-between mt-2">
                <div className="flex items-center border-1 rounded-md border-gray-300 w-full h-12 p-2 bg-white">
                    {aboutImage ? (
                        <div className='w-full flex items-center justify-between p-1'>
                            {/* Image name displayed on the left */}
                            <div className='text-[15px] text-black'>
                                {aboutImage.split('/').pop().slice(0, 25)}...
                            </div>
                            
                            {/* Trash icon inside the same div, aligned to the right */}
                            <button 
                              className=" cursor-pointer "  
                              type="button"
                              onClick={removeAboutImage}
                            >
                                <img src={trash} alt="Trash" className='w-6'/>
                            </button>
                        </div>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="flex items-center justify-center bg-[#5E35B1] text-white border rounded-md px-2 py-1 text-sm hover:bg-purple-700 focus:outline-none"
                                onClick={() => aboutFileInputRef.current.click()}
                            >
                                Upload image
                            </button>
                            <p className='mt-3 ml-2'>No file chosen</p>
                        </>
                    )}
                </div>  
                {/* Hidden File Input */}
                <input
                  type="file"
                  accept="image/*"
                  ref={aboutFileInputRef}
                  className="hidden"
                  onChange={handleAboutFileChange}
                />
              </div>
              
              {errors.about_image && (
                <span className="text-red-500 text-sm mt-1 block">{errors.about_image}</span>
              )}
            </div>

            <div className="flex flex-col relative">
              <label className="text-sm text-gray-600 mb-1">Mission<span className="text-red-500">*</span></label>

              <div className="relative">
                <textarea
                  placeholder="Write Here..."
                  rows="4"
                  className="input-field pr-10"
                  value={formData.history}
                  onChange={(e) =>
                    setFormData({ ...formData, history: e.target.value })
                  }
                ></textarea>
                {errors.history && <span className="text-red-500 text-sm">{errors.history}</span>}
              </div>

              <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center border-1 rounded-md border-gray-300 w-full h-12 p-2 bg-white">
                    {historyImage ? (
                        <div className='w-full flex items-center justify-between p-1'>
                            {/* Image name displayed on the left */}
                            <div className='text-[15px] text-black'>
                                {historyImage.split('/').pop().slice(0, 25)}...
                            </div>
                            
                            {/* Trash icon inside the same div, aligned to the right */}
                            <button 
                              className=" cursor-pointer "  
                              type="button"
                              onClick={removeHistoryImage}
                            >
                                <img src={trash} alt="Trash" className='w-6'/>
                            </button>
                        </div>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="flex items-center justify-center bg-[#5E35B1] text-white border rounded-md px-2 py-1 text-sm hover:bg-purple-700 focus:outline-none"
                                 onClick={() => historyFileInputRef.current.click()}
                            >
                                Upload image
                            </button>
                            <p className='mt-3 ml-2'>No file chosen</p>
                        </>
                    )}
                </div>  

                {/* Hidden File Input */}
                <input
                  type="file"
                  accept="image/*"
                  ref={historyFileInputRef}
                  className="hidden"
                  onChange={handleHistoryFileChange}
                />
              </div>

              {errors.history_image && (
                <span className="text-red-500 text-sm mt-1 block">{errors.history_image}</span>
              )}
            </div>

            <div className="flex flex-col relative">
              <label className="text-sm text-gray-600 mb-1">Vision<span className="text-red-500">*</span></label>
              <div className="relative">
                <textarea
                  placeholder="Write Here..."
                  rows="4"
                  className="input-field pr-10"
                  value={formData.why_us}
                  onChange={(e) =>
                    setFormData({ ...formData, why_us: e.target.value })
                  }
                ></textarea>
                {errors.why_us && <span className="text-red-500 text-sm">{errors.why_us}</span>}
              </div>

              <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center border-1 rounded-md border-gray-300 w-full h-12 p-2 bg-white">
                    {whyUsImage ? (
                        <div className='w-full flex items-center justify-between p-1'>
                            {/* Image name displayed on the left */}
                            <div className='text-[15px] text-black'>
                                {whyUsImage.split('/').pop().slice(0, 25)}...
                            </div>
                            
                            {/* Trash icon inside the same div, aligned to the right */}
                            <button 
                              className=" cursor-pointer "  
                              type="button"
                              onClick={removeWhyUsImage}
                            >
                                <img src={trash} alt="Trash" className='w-6'/>
                            </button>
                        </div>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="flex items-center justify-center bg-[#5E35B1] text-white border rounded-md px-2 py-1 text-sm hover:bg-purple-700 focus:outline-none"
                                onClick={() => whyUsFileInputRef.current.click()}
                            >
                                Upload image
                            </button>
                            <p className='mt-3 ml-2'>No file chosen</p>
                        </>
                    )}
                </div>  

                {/* Hidden File Input */}
                <input
                  type="file"
                  accept="image/*"
                  ref={whyUsFileInputRef}
                  className="hidden"
                  onChange={handleWhyUsFileChange}
                />
              </div>

              {errors.why_us_image && (
                <span className="text-red-500 text-sm mt-1 block">{errors.why_us_image}</span>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            {/* Value */}
            <div className="flex flex-col relative">
              <label className="text-sm text-gray-600 mb-1">Value<span className="text-red-500">*</span></label>
              <div className="relative">
                <textarea
                  placeholder="Write Here..."
                  rows="4"
                  className="input-field pr-10"
                  value={formData.value}
                  onChange={(e) => setFormData({ ...formData, value: e.target.value })}
                ></textarea>
                {errors.value && <span className="text-red-500 text-sm">{errors.value}</span>}
              </div>

              <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center border-1 rounded-md border-gray-300 w-full h-12 p-2 bg-white">
                    {valueImage ? (
                        <div className='w-full flex items-center justify-between p-1'>
                            {/* Image name displayed on the left */}
                            <div className='text-[15px] text-black'>
                                {valueImage.split('/').pop().slice(0, 25)}...
                            </div>
                            
                            {/* Trash icon inside the same div, aligned to the right */}
                            <button 
                              className=" cursor-pointer "  
                              type="button"
                               onClick={removeValueImage}
                            >
                                <img src={trash} alt="Trash" className='w-6'/>
                            </button>
                        </div>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="flex items-center justify-center bg-[#5E35B1] text-white border rounded-md px-2 py-1 text-sm hover:bg-purple-700 focus:outline-none"
                                onClick={() => valueFileInputRef.current.click()}
                            >
                                Upload image
                            </button>
                            <p className='mt-3 ml-2'>No file chosen</p>
                        </>
                    )}
                </div>  

                {/* Hidden File Input */}
                 <input
                  type="file"
                  accept="image/*"
                  ref={valueFileInputRef}
                  className="hidden"
                  onChange={handleValueFileChange}
                />
              </div>

              {errors.value_image && (
                <span className="text-red-500 text-sm mt-1 block">{errors.value_image}</span>
              )}
            </div>
          </div>

          {/* Save Button */}
          <div className="flex justify-center">
            <button
              type="submit"

              className="px-10 py-2 bg-primary_main text-white rounded-lg hover:bg-primary_main transition"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default School_profile
